import React from 'react'
import styles from './AdManagerRunning.module.css'
import { FaHome } from 'react-icons/fa';
import adlogo from '../Images/AdManagerLogo.png'
import Billlogo from '../Images/BillingLogo.png'
import compai from '../Images/compain.png'
import down from '../Images/whitedown.png'
import graph from '../Images/graph.png'
import { Link } from "react-router-dom";


const AdManagerRunning = () => {
    return (
        <>
            <div className={styles.home}>
                <div className={styles.side}>
                    <Link to="/home" className={styles.homeTitle}>
                        <FaHome size={22} className={styles.logo} />
                        <div className={styles.text}>Home</div>
                    </Link>
                    <Link to="/compainpeformance" className={styles.manager1}>
                        <div className={styles.admanag}><img src={adlogo} alt="" /></div>
                        <div className={styles.text}>Ad Performance</div>
                    </Link>
                    <div className={styles.manager}>
                        <div className={styles.admanag}><img src={compai} alt="" /></div>
                        <div className={styles.text}>Campaign name</div>
                    </div>
                    <Link to="/admanager" className={styles.manager1}>
                        <div className={styles.admanag}><img src={adlogo} alt="" /></div>
                        <div className={styles.text}>Ad manager</div>
                    </Link>
                    <Link to="/billing" className={styles.manager}>
                        <div className={styles.admanag}><img src={Billlogo} alt="" /></div>
                        <div className={styles.text}>Billing</div>
                    </Link>

                </div>
                <div className={styles.right}>
                    <div className={styles.inner}>
                        <button className={styles.create}>Create campaign</button>
                        <div className={styles.graph}>
                            <div className={styles.impess}>
                                <div className={styles.impression} >
                                    <div className={styles.impro}>
                                        <div className={styles.white}>Impressions</div>
                                        <img src={down} alt="" className={styles.downarr} />
                                    </div>
                                    <div className={styles.num}>1.2K</div>
                                </div>
                                <div className={styles.impression1}>
                                    <div className={styles.impro}>
                                        <div className={styles.white}>Clicks</div>
                                        <img src={down} alt="" className={styles.downarr} />
                                    </div>
                                    <div className={styles.num}>600</div>
                                </div>
                                <div className={styles.impression2}>
                                    <div className={styles.impro}>
                                        <div className={styles.white}>Cost $Mads</div>
                                        <img src={down} alt="" className={styles.downarr} />
                                    </div>
                                    <div className={styles.num}>1K</div>
                                </div>
                                <div className={styles.reamin}></div>
                            </div>
                            <div className={styles.graph12}>
                                <img src={graph} className={styles.graphimg} alt="" />
                                
                            </div>
                        </div>
                        <div className={styles.camp}>
                            <div className={styles.title}><div style={{ marginLeft: "26px", marginTop: "23px" }}> Campaigns</div> </div>
                            <div className={styles.loerInner}>
                                <div className={styles.greycompin}>
                                    <div style={{ marginTop: "auto" }}>
                                        <div className={styles.greyButon}><div>Campaign 1</div></div>
                                        <div className={styles.greyButon} style={{ marginTop: "9px" }}><div>Campaign 2</div></div>
                                        <div className={styles.greyButon} style={{ marginTop: "9px" }}><div>Campaign 3</div></div>
                                    </div>
                                </div>
                                <div className={styles.table}>
                                    <div className={styles.ikmpr}>
                                        <div className={styles.road}><div >Impr Road</div></div>
                                        <div className={styles.road1}><div >600</div></div>
                                        <div className={styles.road1}><div >53</div></div>
                                        <div className={styles.road1}><div >700</div></div>

                                    </div>
                                    <div className={styles.ikmpr1}>
                                        <div className={styles.road}><div>Impr Wallet</div></div>
                                        <div className={styles.road1}><div>600</div></div>
                                        <div className={styles.road1}><div>53</div></div>
                                        <div className={styles.road1}><div>700</div></div>

                                    </div>
                                    <div className={styles.ikmpr1}>
                                        <div className={styles.orang}><div>Clicks</div></div>
                                        <div className={styles.road1}><div>300</div></div>
                                        <div className={styles.road1}><div>80</div></div>
                                        <div className={styles.road1}><div>220</div></div>

                                    </div>
                                    <div className={styles.spend}>
                                        <div className={styles.red}><div>Total Spend</div></div>
                                        <div className={styles.road1}><div>450</div></div>
                                        <div className={styles.road1}><div>70</div></div>
                                        <div className={styles.road1}><div>500</div></div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdManagerRunning
